import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";

export default function View({ uuid }) {
  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [data, setData] = useState(null);

  async function init() {
    setReady(false);
    await Promise.all([getData()]);
    setReady(true);
  }

  async function getData() {
    await callApi("get-product-data", { uuid }).then((response) => {
      if (response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data");
      }
    });
  }

  useEffect(() => {
    init();
  }, [uuid]);

  if (ready && data) {
    return (
      <div className="view-detail-wrapper">
        <style>{`
          .view-detail-wrapper {
            position: relative;
            width: 100%;
            min-height: 100vh;
            background-color: #020617;
            color: #f1f5f9;
            padding-top: calc(80px + var(--topBarHeight, 0px));
            padding-bottom: 80px;
            font-family: 'Inter', system-ui, sans-serif;
          }

          .view-card-glass {
            background: rgba(255, 255, 255, 0.02);
            backdrop-filter: blur(20px);
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: clamp(16px, 3vw, 28px);
            padding: clamp(20px, 5vw, 50px);
            box-shadow: 0 30px 80px -20px rgba(0, 0, 0, 0.6);
          }

          .view-cover-img {
            width: 100%;
            max-height: 500px;
            object-fit: cover;
            border-radius: 16px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
          }

          .view-title {
            font-size: clamp(1.8rem, 4vw, 2.8rem);
            font-weight: 800;
            line-height: 1.2;
            color: #ffffff;
            letter-spacing: -0.03em;
          }

          .view-subtitle {
            font-size: clamp(1rem, 2vw, 1.25rem);
            color: #94a3b8;
            font-weight: 400;
            line-height: 1.6;
          }

          .view-body-content {
            color: #cbd5e1;
            font-size: 1.05rem;
            line-height: 1.8;
          }

          .view-body-content p {
            margin-bottom: 1.25rem;
          }

          .view-body-content img {
            max-width: 100%;
            height: auto;
            border-radius: 12px;
            margin: 1.5rem 0;
          }

          .view-divider {
            border-color: rgba(255, 255, 255, 0.1);
            margin: 1.5rem 0;
          }
        `}</style>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="view-card-glass">
                {/* Header Title */}
                {data.title && (
                  <div className="mb-3">
                    <h1 className="view-title">{data.title}</h1>
                  </div>
                )}

                {/* Subtitle / Description */}
                {data.description && (
                  <div className="mb-4">
                    <p className="view-subtitle">{data.description}</p>
                  </div>
                )}

                {/* Cover Photo */}
                {data.coverPhoto && (
                  <div className="mb-4">
                    <img
                      src={CDN_URL + data.coverPhoto}
                      alt={data.title || "Cover Image"}
                      className="view-cover-img"
                    />
                  </div>
                )}

                {/* Date Created */}
                {data.dateCreated && (
                  <div className="mb-3">
                    <p className="text-end text-uppercase fw-semibold text-muted small m-0" style={{ letterSpacing: "1px", color: "var(--secondaryColor, #38bdf8)" }}>
                      {formatDate(data.dateCreated)}
                    </p>
                    <hr className="view-divider" />
                  </div>
                )}

                {/* Main Body HTML Content */}
                {data.body && (
                  <div
                    className="view-body-content"
                    dangerouslySetInnerHTML={{ __html: data.body }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container py-5 text-center my-5">
        {getInlineLoader ? getInlineLoader() : <div className="text-white">Loading...</div>}
      </div>
    );
  }
}